// OTOMATIK ÜRETİLDİ — scripts/sync_shopify.py ile güncellenir. Elle düzenlemeyin.
// Kaynak: https://www.atilmazsaat.com/products.json — 73 ürün

export const PRODUCTS = [
  {
    "id": "casio-w-96h-2avdf",
    "name": "Casio W-96H-2AVDF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 2199,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_4c93b9f5-35ca-483f-8a5b-664ce8839d96.png?v=1789645808&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-w-96h-2avdf"
  },
  {
    "id": "casio-w-96h-1avdf",
    "name": "Casio W-96H-1AVDF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 2199,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_e1e4ae7d-1908-4126-8f8c-54c1c07eba81.png?v=1789645807&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-w-96h-1avdf"
  },
  {
    "id": "casio-mw-620h-3avdf",
    "name": "Casio MW-620H-3AVDF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 2899,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_0bbf1731-6576-477b-b267-e2022cb65fe3.png?v=1789645806&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-mw-620h-3avdf"
  },
  {
    "id": "casio-mw-620h-2avdf",
    "name": "Casio MW-620H-2AVDF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 2899,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_72fb75b9-ba73-41fa-b49b-28ac72849c3f.png?v=1789645805&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-mw-620h-2avdf"
  },
  {
    "id": "casio-mtp-v300d-1eudf",
    "name": "Casio MTP-V300D-1EUDF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 4399,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_77fd1ec6-28dd-439f-a278-ab308f3e539d.png?v=1789645805&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-mtp-v300d-1eudf"
  },
  {
    "id": "casio-mtp-v001d-1e2vudf",
    "name": "Casio MTP-V001D-1E2VUDF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 3199,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_b1109ae4-04e6-448b-a890-46943111e01b.jpg?v=1789645804&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-mtp-v001d-1e2vudf"
  },
  {
    "id": "casio-mtp-v001d-1bvdf",
    "name": "Casio MTP-V001D-1BVDF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 3199,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_8fd649cc-9975-4d7d-8eac-5b2832e12c24.jpg?v=1789645803&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-mtp-v001d-1bvdf"
  },
  {
    "id": "casio-mtp-v004d-1b2udf",
    "name": "Casio MTP-V004D-1B2UDF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 2299,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_93801c7d-cce8-43a2-91d0-0686c2ef74c6.png?v=1789645803&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-mtp-v004d-1b2udf"
  },
  {
    "id": "casio-mtp-v002d-1budf",
    "name": "Casio MTP-V002D-1BUDF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 2199,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_25303c38-9235-4f0e-80da-2304bf97c59a.png?v=1789645803&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-mtp-v002d-1budf"
  },
  {
    "id": "casio-mtp-1374d-2avdf",
    "name": "Casio MTP-1374D-2AVDF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 5499,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_a86ab48a-54c9-4121-9b31-8138b77bce5e.png?v=1789645802&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-mtp-1374d-2avdf"
  },
  {
    "id": "casio-mtp-1314d-1avdf",
    "name": "Casio MTP-1314D-1AVDF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 3299,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_302255cb-6f7e-4f82-8236-b2fef550bb4a.png?v=1789645802&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-mtp-1314d-1avdf"
  },
  {
    "id": "casio-mtp-1303dd-1avdf",
    "name": "Casio MTP-1303DD-1AVDF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 3199,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_c9de44a7-f9e0-4ce1-9a3f-bc94a1638cc3.png?v=1789645801&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-mtp-1303dd-1avdf"
  },
  {
    "id": "casio-mtp-1239d-1adf",
    "name": "Casio MTP-1239D-1ADF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 3199,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_59dd4654-03e4-456b-883b-3316a5f08cf6.png?v=1789645800&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-mtp-1239d-1adf"
  },
  {
    "id": "casio-mtp-1215a-7adf",
    "name": "Casio MTP-1215A-7ADF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 2999,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_7cd9c607-12c8-4c26-9ddc-1e2d73a9c9eb.png?v=1789645799&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-mtp-1215a-7adf"
  },
  {
    "id": "casio-mtp-1183a-7bdf",
    "name": "Casio MTP-1183A-7BDF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 2999,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_f5b684e4-2c17-49a3-9e62-1d149d58f3ad.png?v=1789645801&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-mtp-1183a-7bdf"
  },
  {
    "id": "casio-mtp-1183a-7adf",
    "name": "Casio MTP-1183A-7ADF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 2999,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_987077e5-48ee-4459-bf51-35398a72fd53.png?v=1789645799&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-mtp-1183a-7adf"
  },
  {
    "id": "casio-mtp-135d-2avdf",
    "name": "Casio MTP-135D-2AVDF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 7199,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_c138bb1e-5ed2-4eb7-b404-98d5badb77c8.png?v=1789645798&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-mtp-135d-2avdf"
  },
  {
    "id": "casio-mtp-135d-1avdf",
    "name": "Casio MTP-135D-1AVDF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 7199,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_324f8aa5-95b3-497e-bb8a-cbbf915882b6.png?v=1789645797&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-mtp-135d-1avdf"
  },
  {
    "id": "casio-mtp-125d-1a3vdf",
    "name": "Casio MTP-125D-1A3VDF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 2999,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/MTP-125D-1A3VDF.png?v=1789815465&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-mtp-125d-1a3vdf"
  },
  {
    "id": "casio-ltp-v007g-9eudf",
    "name": "Casio LTP-V007G-9EUDF Kadın Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "kadin",
    "price": 2499,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_197b6086-55b3-43c6-a4a3-23f3a12c87da.jpg?v=1789808512&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-ltp-v007g-9eudf"
  },
  {
    "id": "casio-ltp-v007d-7eudf",
    "name": "Casio LTP-V007D-7EUDF Kadın Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "kadin",
    "price": 2299,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_4365fb03-14b9-4b2a-b346-fcf8eb6ca343.jpg?v=1789808508&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-ltp-v007d-7eudf"
  },
  {
    "id": "casio-ltp-v004d-7b2udf",
    "name": "Casio LTP-V004D-7B2UDF Kadın Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "kadin",
    "price": 2299,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_4049bdb5-fbe0-4494-8f5b-6cf49cefbe42.png?v=1789808506&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-ltp-v004d-7b2udf"
  },
  {
    "id": "casio-ltp-v002gl-7budf",
    "name": "Casio LTP-V002GL-7BUDF Kadın Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "kadin",
    "price": 2199,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_d776a388-cd8a-4487-8d67-f8c09244da25.png?v=1789808504&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-ltp-v002gl-7budf"
  },
  {
    "id": "casio-ltp-v002g-7b2udf",
    "name": "Casio LTP-V002G-7B2UDF Kadın Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "kadin",
    "price": 2699,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image.jpg?v=1789645794&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-ltp-v002g-7b2udf"
  },
  {
    "id": "casio-ltp-v002d-7b3udf",
    "name": "Casio LTP-V002D-7B3UDF Kadın Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "kadin",
    "price": 2399,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/LTP-V002D-7B3UDF.png?v=1789815522&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-ltp-v002d-7b3udf"
  },
  {
    "id": "casio-ltp-v002d-7audf",
    "name": "Casio LTP-V002D-7AUDF Kadın Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "kadin",
    "price": 2299,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_20684782-cd4c-46dd-89ae-c5b1b2fcdce8.png?v=1789645793&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-ltp-v002d-7audf"
  },
  {
    "id": "casio-ltp-v002d-4budf",
    "name": "Casio LTP-V002D-4BUDF Kadın Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "kadin",
    "price": 2299,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_f90a1334-d90f-4823-a0ff-818516f34e29.jpg?v=1789645792&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-ltp-v002d-4budf"
  },
  {
    "id": "casio-ltp-v002d-1budf",
    "name": "Casio LTP-V002D-1BUDF Kadın Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "kadin",
    "price": 2199,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_91f9e9d1-7c1f-4a0b-9bdb-02b04f8e220b.jpg?v=1789645792&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-ltp-v002d-1budf"
  },
  {
    "id": "casio-ltp-1335d-7avdf",
    "name": "Casio LTP-1335D-7AVDF Kadın Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "kadin",
    "price": 3499,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/LTP-1335D-7AVDF_e4dc3a3a-9426-467c-9765-2cc1394d6208.png?v=1789815459&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-ltp-1335d-7avdf"
  },
  {
    "id": "casio-ltp-1335d-1avdf",
    "name": "Casio LTP-1335D-1AVDF Kadın Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "kadin",
    "price": 3499,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/LTP-1335D-1AVDF.jpg?v=1789815455&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-ltp-1335d-1avdf"
  },
  {
    "id": "casio-ltp-1303dd-7avdf",
    "name": "Casio LTP-1303DD-7AVDF Kadın Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "kadin",
    "price": 3199,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_13f4d8bb-b5ad-46d7-a1dd-9e640d21d4f8.png?v=1789645790&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-ltp-1303dd-7avdf"
  },
  {
    "id": "casio-ltp-1302d-7bvdf",
    "name": "Casio LTP-1302D-7BVDF Kadın Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "kadin",
    "price": 2999,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_bd3e1458-42c0-4265-835b-b0d4ed8c47cf.png?v=1789645789&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-ltp-1302d-7bvdf"
  },
  {
    "id": "casio-ltp-1275d-7bdf",
    "name": "Casio LTP-1275D-7BDF Kadın Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "kadin",
    "price": 2599,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/LTP-1275D-7BDF.png?v=1789815452&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-ltp-1275d-7bdf"
  },
  {
    "id": "casio-ltp-1241d-7a2df",
    "name": "Casio LTP-1241D-7A2DF Kadın Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "kadin",
    "price": 2399,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/LTP-1241D-7A2DF.jpg?v=1789815518&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-ltp-1241d-7a2df"
  },
  {
    "id": "casio-ltp-1241d-4a3df",
    "name": "Casio LTP-1241D-4A3DF Kadın Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "kadin",
    "price": 2399,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/LTP-1241D-4A3DF.jpg?v=1789815446&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-ltp-1241d-4a3df"
  },
  {
    "id": "casio-ltp-1215a-7adf",
    "name": "Casio LTP-1215A-7ADF Kadın Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "kadin",
    "price": 2799,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/LTP-1215A-7ADF.jpg?v=1789815514&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-ltp-1215a-7adf"
  },
  {
    "id": "casio-ltp-1215a-1a2df",
    "name": "Casio LTP-1215A-1A2DF Kadın Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "kadin",
    "price": 2799,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/LTP-1215A-1A2DF.jpg?v=1789815510&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-ltp-1215a-1a2df"
  },
  {
    "id": "casio-ltp-1128g-7brdf",
    "name": "Casio LTP-1128G-7BRDF Kadın Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "kadin",
    "price": 3399,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/LTP-1128G-7BRDF.png?v=1789815526&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-ltp-1128g-7brdf"
  },
  {
    "id": "casio-la670wa-7df",
    "name": "Casio LA670WA-7DF Kadın Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "kadin",
    "price": 2299,
    "oldPrice": null,
    "available": false,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/LA670WA-7DF.jpg?v=1789815505&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-la670wa-7df"
  },
  {
    "id": "casio-la670wa-1df",
    "name": "Casio LA670WA-1DF Kadın Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "kadin",
    "price": 2199,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/LA670WA-1DF.jpg?v=1789815499&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-la670wa-1df"
  },
  {
    "id": "casio-ga-110rl-1adr",
    "name": "Casio GA-110RL-1ADR Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 9499,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_7994e805-fa9e-4247-bbfc-3270b1e5dc99.png?v=1789645784&width=900",
    "imageAlt": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_11489286-b5f3-4925-aca0-2b7c9f9b28a8.png?v=1789814830&width=900",
    "url": "https://www.atilmazsaat.com/products/casio-ga-110rl-1adr"
  },
  {
    "id": "casio-ga-010-1a1dr",
    "name": "Casio GA-010-1A1DR Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 9499,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_4e65afe2-ed42-428e-a4e2-a3e375c91c79.png?v=1789645784&width=900",
    "imageAlt": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_6eef658b-bf1a-4e4c-b88e-3e0daa7b238b.png?v=1789814829&width=900",
    "url": "https://www.atilmazsaat.com/products/casio-ga-010-1a1dr"
  },
  {
    "id": "casio-efv-630d-1avudf",
    "name": "Casio EFV-630D-1AVUDF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 8699,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/EFV-630D-1AVUDF.png?v=1789815416&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-efv-630d-1avudf"
  },
  {
    "id": "casio-ef-129d-2avdf",
    "name": "Casio EF-129D-2AVDF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 8499,
    "oldPrice": null,
    "available": false,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/EF-129D-2AVDF.jpg?v=1789815495&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-ef-129d-2avdf"
  },
  {
    "id": "casio-edifice-era-130d-1adf",
    "name": "Casio EDIFICE ERA-130D-1ADF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 12499,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_de684a54-95cc-46c3-8eba-c1ad1a3dc0b2.png?v=1789808502&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-edifice-era-130d-1adf"
  },
  {
    "id": "casio-amw-870da-2a1vdf",
    "name": "Casio AMW-870DA-2A1VDF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 6999,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_21d5c705-6fa9-435a-984c-7bbec03ae8a5.png?v=1789645781&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-amw-870da-2a1vdf"
  },
  {
    "id": "casio-aeq-110w-3avdf",
    "name": "Casio AEQ-110W-3AVDF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 3899,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_64889889-3c81-4d29-980e-81f6128357d4.jpg?v=1789808490&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-aeq-110w-3avdf"
  },
  {
    "id": "casio-ae-1600h-1avdf",
    "name": "Casio AE-1600H-1AVDF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 3199,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_04bb9644-a510-4cd0-8f31-fac7ab0b66f4.png?v=1789645781&width=900",
    "imageAlt": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_90403ef2-26a2-4bda-80fa-61bc71ae70c3.png?v=1789814842&width=900",
    "url": "https://www.atilmazsaat.com/products/casio-ae-1600h-1avdf"
  },
  {
    "id": "casio-ae-1000w-4bvdf",
    "name": "Casio AE-1000W-4BVDF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 2499,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_2d7eb56a-32e6-4253-94e9-15402566f3e1.png?v=1789645780&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-ae-1000w-4bvdf"
  },
  {
    "id": "casio-ws-1500h-1avdf",
    "name": "Casio WS-1500H-1AVDF Erkek Kol Saati",
    "brand": "Casio",
    "category": "saat",
    "gender": "erkek",
    "price": 2999,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_fca2c702-fba2-4b08-b868-318a765bd4de.png?v=1789645807&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/casio-ws-1500h-1avdf"
  },
  {
    "id": "valentino-orlandi-otomatik-erkek-kol-saati-celik-kordon-premium-seri",
    "name": "Valentino Orlandi Otomatik Erkek Kol Saati – Çelik Kordon",
    "brand": "Valentino Orlandi",
    "category": "saat",
    "gender": "erkek",
    "price": 12999,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/valentino-orlandi-lifestyle-v2.png?v=1789532752&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/valentino-orlandi-otomatik-erkek-kol-saati-celik-kordon-premium-seri"
  },
  {
    "id": "valentino-orlandi-beyaz-kadran-otomatik-makina",
    "name": "Valentino Orlandi Otomatik Erkek Kol Saati – Beyaz Kadran Çelik Kordon",
    "brand": "Valentino Orlandi",
    "category": "saat",
    "gender": "erkek",
    "price": 21990,
    "oldPrice": null,
    "available": true,
    "image": "",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/valentino-orlandi-beyaz-kadran-otomatik-makina"
  },
  {
    "id": "valentino-orlandi-altn-ton-geometrik-kadn-kol-saati",
    "name": "Valentino Orlandi Altın Ton Geometrik Kadın Kol Saati",
    "brand": "Valentino Orlandi",
    "category": "saat",
    "gender": "kadin",
    "price": 13490,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_e3dc18f8-38e3-491e-a038-db9504e7361a.png?v=1790148948&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/valentino-orlandi-altn-ton-geometrik-kadn-kol-saati"
  },
  {
    "id": "valentino-orlandi-altn-kaplama",
    "name": "Valentino Orlandi Altın Kaplama Kadın Kol Saati – Taş Detaylı Kadran",
    "brand": "Valentino Orlandi",
    "category": "saat",
    "gender": "kadin",
    "price": 8990,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_7cb5850d-c8d0-4259-99fe-7ae112d92e0a.png?v=1790148892&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/valentino-orlandi-altn-kaplama"
  },
  {
    "id": "kadn-kol-saati-2",
    "name": "Kadın Kol Saati",
    "brand": "Atılmaz Saat",
    "category": "saat",
    "gender": "kadin",
    "price": 11499,
    "oldPrice": null,
    "available": true,
    "image": "",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/kadn-kol-saati-2"
  },
  {
    "id": "kadn-kol-saati",
    "name": "Kadın Kol Saati – Paslanmaz Çelik Quartz",
    "brand": "Atılmaz Saat",
    "category": "saat",
    "gender": "kadin",
    "price": 3599,
    "oldPrice": null,
    "available": true,
    "image": "",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/kadn-kol-saati"
  },
  {
    "id": "daniel-klein-tas-detayl-gold-renk-kadn-bileklik-saat",
    "name": "Daniel Klein Taş Detaylı Gold Renk Kadın Bileklik Saat",
    "brand": "Daniel Klein",
    "category": "taki",
    "gender": "kadin",
    "price": 4220,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/daniel-klein-tas-detayli-gold-kadin-bileklik-saat.jpg?v=1789815860&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/daniel-klein-tas-detayl-gold-renk-kadn-bileklik-saat"
  },
  {
    "id": "daniel-klein-swarovski-tasl-altn-kaplama-kadn-kol-saati",
    "name": "Daniel Klein Swarovski Taşlı Altın Kaplama Kadın Kol Saati",
    "brand": "Daniel Klein",
    "category": "saat",
    "gender": "kadin",
    "price": 3490,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_06aeab7a-b4c0-49c4-bbda-b479071a1d53.png?v=1790148828&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/daniel-klein-swarovski-tasl-altn-kaplama-kadn-kol-saati"
  },
  {
    "id": "danel-klein-set-kadn-saati",
    "name": "Daniel Klein Kadın Kol Saati Seti",
    "brand": "Daniel Klein",
    "category": "saat",
    "gender": "kadin",
    "price": 3999,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_0882544e-17b9-490d-aadc-d837018f1d12.png?v=1790149074&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/danel-klein-set-kadn-saati"
  },
  {
    "id": "danel-klein-preminum-kadn-celik-ve-altn-kaplama-kol-saati",
    "name": "Daniel Klein Premium Kadın Kol Saati – Çelik ve Altın Kaplama",
    "brand": "Daniel Klein",
    "category": "saat",
    "gender": "kadin",
    "price": 5069,
    "oldPrice": null,
    "available": true,
    "image": "",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/danel-klein-preminum-kadn-celik-ve-altn-kaplama-kol-saati"
  },
  {
    "id": "daniel-klein-otomatik-erkek-kol-saati-gumus-metal-kordon-beyaz-kadran-skeleton-tasarm",
    "name": "Daniel Klein Otomatik Erkek Kol Saati – Gümüş Metal Kordon, Beyaz Kadran, Skeleton Tasarım",
    "brand": "Daniel Klein",
    "category": "saat",
    "gender": "erkek",
    "price": 7988,
    "oldPrice": null,
    "available": true,
    "image": "",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/daniel-klein-otomatik-erkek-kol-saati-gumus-metal-kordon-beyaz-kadran-skeleton-tasarm"
  },
  {
    "id": "daniel-klein-kadn-bileklik-saat-zarif-tasarm-gold-renk",
    "name": "Daniel Klein Kadın Kol Saati – Gold Renk",
    "brand": "Daniel Klein",
    "category": "saat",
    "gender": "kadin",
    "price": 3500,
    "oldPrice": null,
    "available": true,
    "image": "",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/daniel-klein-kadn-bileklik-saat-zarif-tasarm-gold-renk"
  },
  {
    "id": "danel-klein-gunes-gozlugu",
    "name": "Daniel Klein Güneş Gözlüğü",
    "brand": "Daniel Klein",
    "category": "taki",
    "gender": null,
    "price": 3250,
    "oldPrice": null,
    "available": true,
    "image": "",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/danel-klein-gunes-gozlugu"
  },
  {
    "id": "danel-klein-exclusve-jubile-bancet-celik-kol-saati",
    "name": "Daniel Klein Exclusive Erkek Kol Saati – Jübile Bancet Çelik",
    "brand": "Daniel Klein",
    "category": "saat",
    "gender": "erkek",
    "price": 4499,
    "oldPrice": null,
    "available": true,
    "image": "",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/danel-klein-exclusve-jubile-bancet-celik-kol-saati"
  },
  {
    "id": "daniel-klein-erkek-kol-saati-yesil-kadran-gold-celik",
    "name": "Daniel Klein Erkek Kol Saati – Yeşil Kadran Gold Çelik",
    "brand": "Daniel Klein",
    "category": "saat",
    "gender": "erkek",
    "price": 4100,
    "oldPrice": null,
    "available": true,
    "image": "",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/daniel-klein-erkek-kol-saati-yesil-kadran-gold-celik"
  },
  {
    "id": "daniel-klein-erkek-kol-saati-mavi-kadran-gumus-celik",
    "name": "Daniel Klein Erkek Kol Saati – Mavi Kadran Gümüş Çelik",
    "brand": "Daniel Klein",
    "category": "saat",
    "gender": "erkek",
    "price": 4250,
    "oldPrice": null,
    "available": true,
    "image": "",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/daniel-klein-erkek-kol-saati-mavi-kadran-gumus-celik"
  },
  {
    "id": "daniel-klein-erkek-kol-saati-jubile-celik-kordon-siyah-kadran",
    "name": "Daniel Klein Erkek Kol Saati – Jübile Çelik Kordon Siyah Kadran",
    "brand": "Daniel Klein",
    "category": "saat",
    "gender": "erkek",
    "price": 4349,
    "oldPrice": null,
    "available": true,
    "image": "",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/daniel-klein-erkek-kol-saati-jubile-celik-kordon-siyah-kadran"
  },
  {
    "id": "danel-klein-erkek-kol-saati-siyah-kadran-celik-kordon",
    "name": "Daniel Klein Erkek Kol Saati – Siyah Kadran Çelik Kordon",
    "brand": "Daniel Klein",
    "category": "saat",
    "gender": "erkek",
    "price": 4250,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/DK.1.14265-4.png?v=1789816212&width=900",
    "imageAlt": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/image_10b7aa2b-047d-42fa-9fc2-ba3910d7fba6.png?v=1790142994&width=900",
    "url": "https://www.atilmazsaat.com/products/danel-klein-erkek-kol-saati-siyah-kadran-celik-kordon"
  },
  {
    "id": "danel-klein-erkek-kol-saati",
    "name": "Daniel Klein Erkek Kol Saati",
    "brand": "Daniel Klein",
    "category": "saat",
    "gender": "erkek",
    "price": 4200,
    "oldPrice": null,
    "available": true,
    "image": "",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/danel-klein-erkek-kol-saati"
  },
  {
    "id": "danel-klein-cekik-erkek-bileklik",
    "name": "Daniel Klein Erkek Bileklik",
    "brand": "Daniel Klein",
    "category": "taki",
    "gender": "erkek",
    "price": 1750,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/72EF86EA-9D42-4389-B055-811A2EA479EC.webp?v=1783742854&width=900",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/danel-klein-cekik-erkek-bileklik"
  },
  {
    "id": "daniel-klein-bordo-oval-kadn-kol-saat",
    "name": "Daniel Klein Bordo Oval Kadın Kol Saati",
    "brand": "Daniel Klein",
    "category": "saat",
    "gender": "kadin",
    "price": 3400,
    "oldPrice": null,
    "available": true,
    "image": "",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/daniel-klein-bordo-oval-kadn-kol-saat"
  },
  {
    "id": "danel-klein-altn-kaplama-celik-kadn-bileklik",
    "name": "Daniel Klein Altın Kaplama Çelik Kadın Bileklik",
    "brand": "Daniel Klein",
    "category": "taki",
    "gender": "kadin",
    "price": 1125,
    "oldPrice": null,
    "available": true,
    "image": "",
    "imageAlt": "",
    "url": "https://www.atilmazsaat.com/products/danel-klein-altn-kaplama-celik-kadn-bileklik"
  },
  {
    "id": "altn-kaplama-bileklik",
    "name": "Altın Kaplama Çelik Bileklik",
    "brand": "Atılmaz Saat",
    "category": "taki",
    "gender": null,
    "price": 899,
    "oldPrice": null,
    "available": true,
    "image": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/dbb3f89e-a3b9-4b7b-b3fe-4a082b102217.jpg?v=1784416749&width=900",
    "imageAlt": "https://cdn.shopify.com/s/files/1/0672/7155/7219/files/603e6b84-1cb1-453a-88b8-8792b8f27ed4.jpg?v=1784416778&width=900",
    "url": "https://www.atilmazsaat.com/products/altn-kaplama-bileklik"
  }
];

export const BEST_SELLERS = [
  "casio-w-96h-2avdf",
  "casio-w-96h-1avdf",
  "casio-mw-620h-3avdf",
  "casio-mw-620h-2avdf",
  "casio-mtp-v300d-1eudf",
  "casio-mtp-v001d-1e2vudf",
  "casio-mtp-v001d-1bvdf",
  "casio-mtp-v004d-1b2udf",
  "casio-mtp-v002d-1budf",
  "casio-mtp-1374d-2avdf"
];
